import { isPlatformBrowser } from '@angular/common';
import {
  afterNextRender,
  AfterViewInit,
  ApplicationRef,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  input,
  PLATFORM_ID,
  signal,
  viewChild,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { first } from 'rxjs';
import { Header } from 'src/app/core/models';

import { SwiperContainer } from 'swiper/element/bundle';
import { EffectFade } from 'swiper/modules';
import { Swiper } from 'swiper/types';
@Component({
  selector: 'app-header-slider',
  templateUrl: './header-slider.component.html',
  styleUrls: ['./header-slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeaderSliderComponent {
  private platformId = inject(PLATFORM_ID);

  headers = input<Header[]>([]);

  isBrowser = isPlatformBrowser(this.platformId);
  appRef = inject(ApplicationRef);
  hydrated = toSignal(this.appRef.isStable.pipe(first(stable => stable === true)));
  swiper = viewChild<ElementRef<SwiperContainer>>('swiper');
  swiperInited = signal(false);
  activeSlide = signal(0);

  indexChange(e: Event) {
    this.activeSlide.set((<CustomEvent>e).detail[0].realIndex || 0);
  }

  slideNext() {
    this.swiper()?.nativeElement?.swiper?.slideNext();
  }
  slidePrev() {
    this.swiper()?.nativeElement?.swiper?.slidePrev();
  }
}
